<template>
  <ul class="boletos__lista">
    <li class="boletos__lista-item" :class="financiamentoEstaBloqueado || cobranca.EstaBloqueada ? 'boletos__lista-item-bloqueado' : ''" v-for="cobranca in cobrancas" :key="cobranca.Id">
      <MensagemFlutuante :mensagemVisivel="mensagemVisivel" :estilo="estiloMensagem" :texto="textoMensagem" @close="fecharMensagem" />
      <div class="boletos__lista-informacoes-principais">
          <label v-if="podeSelecionarParcelas" class="formulario__input-checkbox" :aria-label="'Selecionar ' +  obterTituloDaCobranca(cobranca)">
              <input v-model="parcelasSelecionadas" :value="cobranca" type="checkbox" tabindex="1" :checked="estaMarcado" @change="validarSeCobrancaPossuiRegraDivergente(cobranca, $event)" 
              :disabled="!cobranca.PodeSerSelecionada">
              <span class="formulario__marcador" :class="cobranca.PodeSerSelecionada ? '' : 'formulario_input-desabilitado'"></span>
        </label>
        <div class="boletos__lista-icone">
          <i class="fal fa-file-alt"></i>
        </div>
        <div class="boletos__lista-conteudo">
          <div class="boletos__parcela" tabindex="1">
            <strong class="texto texto_pequeno texto_cor-alerta" v-show="cobranca.EstaBloqueada || financiamentoEstaBloqueado">
              <i class="far fa-lock-alt fa-1x u-margem-direita-mini fa_cor-erro"></i>
              BLOQUEADA
            </strong>
            <div class="boletos__parcela-numero">{{ obterTituloDaCobranca(cobranca) }}</div>
            <div class="boletos__parcela-vencimento">Vencimento: {{ cobranca.VencimentoFormatado }}</div>
          </div>
          <div class="boletos__valor-do-boleto" tabindex="1">
            <div>Valor total da parcela</div>
            <div class="boletos__valor-da-parcela">R$ {{ formatarValorMonetarioParaExibicao(cobranca.Total) }}</div>
          </div>
          <button type="button" tabindex="1" :aria-label="'Mostrar detalhes da ' +  obterTituloDaCobranca(cobranca)" @click="mostraAba = mostraAba == cobranca.Id ? '' : cobranca.Id"
            class="botao botao_icone botao_sem-preenchimento ver-composicao-da-parcela">
            <span v-show="mostraAba == '' || mostraAba != cobranca.Id">
              <i class="fal fa-chevron-down"></i>
            </span>
            <span v-show="mostraAba == cobranca.Id">
              <i class="fal fa-chevron-up"></i>
            </span>
          </button>
        </div>
      </div>
      <div v-show="mostraAba == cobranca.Id" class="lista-de-boletos__composicao-da-parcela"
        :class="mostraAba ? 'classe-que-abre' : ''" tabindex="1">
        <table class="tabela tabela_com-borda tabela_com-largura-total">
              <caption class="titulo titulo_mini u-texto-alinhado-a-esquerda u-margem-pequena">Composição da {{ obterTituloDaCobranca(cobranca) }} </caption>
          <thead>
            <tr>
              <th>Valor da Parcela:</th>
              <th>Valor de Correção:</th>
              <th>Valor de Mora:</th>
              <th>Valor de Multa:</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> R$ {{ formatarValorMonetarioParaExibicao(cobranca.Valor) }}</td>
              <td>R$ {{ formatarValorMonetarioParaExibicao(cobranca.Correcao) }}</td>
              <td> R$ {{ formatarValorMonetarioParaExibicao(cobranca.Mora) }}</td>
              <td>R$ {{ formatarValorMonetarioParaExibicao(cobranca.Multa) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </li>
  </ul>
</template>
<script>
import {formatacaoDeValores} from '../../mixins/formatacaoDeValoresMixin.js';
import utils from '../../helpers/utilsDeSelecaoDeCobrancas.js';
import MensagemFlutuante from '../../componentes/mensagemFlutuante/mensagemFlutuante.vue';

export default {
  components: { MensagemFlutuante },
  data() {
    return {
      mostraAba: '',
      parcelasSelecionadasLocal: [],
      mensagemVisivel: false,
      textoMensagem: '',
      estiloMensagem: '',
      tituloMensagem: '',
      estaMarcado: false
    }
  },
  props: {
    cobrancas: {
      type: Array,
      default: []
    },
    prazo: {
      type: Number,
      default: 0
    },
    selecionarTodasAsParcelas: {
      type: Boolean,
      default: false
    },
    podeSelecionarParcelas: {
      type: Boolean,
      default: false
    },
    financiamentoEstaBloqueado: {
      type: Boolean,
      default: false
    },
    financiamentoEhReurbE: {
      type: Boolean,
      default: false
    },
    possuiDivergenciaDeRegraDePrimeiraParcela: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => ([])
    }
  },
  mixins: [
    formatacaoDeValores
  ],
  methods: {
    obterTituloDaCobranca(cobranca) {
      return cobranca.EhEntrada ? 'Entrada da Novação' : 'Parcela: ' + cobranca.Parcela + '/' + this.prazo;
    },
    tratarDesmarcacaoForaDaOrdem(numerosDasParcelasSelecionadas) {
      let numerosOrdenados = numerosDasParcelasSelecionadas.sort((n1, n2) => {
        return n1 < n2 ? -1 : 1
      })

      const menorNumeroSelecionavel = this.obterMenorNumeroParaSelecionar()
      const primeiroNumeroSelecionavelEstaSelecionado = numerosOrdenados.includes(menorNumeroSelecionavel)
      const numeroDaParcelaNaValidade = this.obterNumeroDaParcelaNaValidade()

      if(!primeiroNumeroSelecionavelEstaSelecionado)
        return numerosOrdenados.filter(n => n === numeroDaParcelaNaValidade)

      numerosOrdenados.every(numero => {
        const proximoNumero = this.obterProximoNumeroDeParcelaNaOrdem(numero)
            if(!numerosOrdenados.includes(proximoNumero)) {
          numerosOrdenados = numerosOrdenados.filter(n => n <= numero || (n === numeroDaParcelaNaValidade && !this.financiamentoEhReurbE))
          return false
        }
        return true
      })
      return numerosOrdenados
    },
    obterProximoNumeroDeParcelaNaOrdem(numeroSelecionado) {
      const cobrancaComNumeroSelecionado = this.cobrancas.find(c => Number(c.Parcela) === numeroSelecionado && !utils.cobrancaEstaNaValidade(c))
      const posicao = this.cobrancas.indexOf(cobrancaComNumeroSelecionado)
      const proximaCobrancaDisponivel = this.cobrancas[posicao + 1]
      const numeroSelecionadoEhOUltimo = posicao === this.cobrancas.length - 1;
      return numeroSelecionadoEhOUltimo ? posicao : Number(proximaCobrancaDisponivel.Parcela)
    },
    obterNumeroDaParcelaNaValidade() {
      const cobrancaNaValidade = this.cobrancas.find(c => {
        return utils.cobrancaEstaNaValidade(c)
      })
      return cobrancaNaValidade ? Number(cobrancaNaValidade.Parcela) : 0
    },
    obterMenorNumeroParaSelecionar() {
      const numerosDasParcelasParaSelecionar = this.cobrancas.map(p => Number(p.Parcela))
      return Math.min(...numerosDasParcelasParaSelecionar)
    },
    validarSeCobrancaPossuiRegraDivergente(cobranca, event){
      const parcela = cobranca.Parcela;
      const podeExibirMensagem = Number(parcela) === 1 && this.possuiDivergenciaDeRegraDePrimeiraParcela === true;
      this.estaMarcado = event.target.checked;

      if(this.estaMarcado && podeExibirMensagem)
        return this.exibirMensagemDeSucesso('Devido ao cancelamento da novação, apenas a primeira parcela pode ser paga.'
        + ' As demais parcelas serão liberadas após esse pagamento.');
    },
    exibirMensagemDeSucesso(mensagem) {
      let estiloDaMensagem = 'atencao';
      this.exibirMensagem(mensagem, estiloDaMensagem);
    },
    exibirMensagem(mensagem, estiloDaMensagem) {
      this.mensagemVisivel = true;
      this.textoMensagem = mensagem;
      this.estiloMensagem = estiloDaMensagem;
      setTimeout(() => { this.fecharMensagem() }, 10000);
    },
    fecharMensagem() {
      this.mensagemVisivel = false;
    },
  },
  watch: {
    selecionarTodasAsParcelas(estaoSelecionadas) {
      this.parcelasSelecionadas = [];

      if (estaoSelecionadas)
        this.parcelasSelecionadas = this.cobrancas;
    },
    parcelasSelecionadasLocal() {
      this.$emit('marcarProximaParcelaSelecionavel')
    },
    cobrancas(cobrancas) {
          if(this.parcelasSelecionadas.length == 0) {
        const menorNumeroParaSelecionar = this.obterMenorNumeroParaSelecionar()
      }
    }
  },
  computed: {
    parcelasSelecionadas: {
      get() {
        return this.value;
      },
      set(val) {
        const numerosDasParcelasSelecionadas = val.map(c => Number(c.Parcela))
        const numerosDasParcelasEmOrdem = this.tratarDesmarcacaoForaDaOrdem(numerosDasParcelasSelecionadas)
        const parcelas = val.filter(c => numerosDasParcelasEmOrdem.includes(Number(c.Parcela)))
        this.parcelasSelecionadasLocal = parcelas
        this.$emit('input', parcelas)
      }
    }
  }
}
</script>
